

























import Vue from 'vue';
import $ from 'jquery';

import LoadingState from '@/components/cards/loading_state/LoadingState.vue';
import { ModalSize } from '@/components/zen_modal/types';
import { includeField } from './helpers';
import Issue from './components/Issue.vue';

export default Vue.extend({
  name: 'JiraIssue',
  components: {
    Issue,
    LoadingState,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    csrfToken: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      issue: null,
      issueFields: null,
      issueEditFields: null,
      issueTransitions: null,
      openInJiraUrl: null,
      isEditing: false,
      isSaving: false,
      isLoaded: false,
    };
  },
  created() {
    this.$emit('updateConfig', { size: ModalSize.Large });
    $.get('/jira/get_issue', { id: this.id }).then(res => {
      this.updateIssue(res);
      this.isLoaded = true;
    });
  },
  methods: {
    edit() {
      this.isEditing = true;
    },
    updateIssue(res) {
      this.issue = res.issue;
      this.issueFields = res.issueFields;
      this.issueEditFields = res.issueEditFields;
      this.issueTransitions = res.issueTransitions;
      this.openInJiraUrl = res.openInJiraUrl;
    },
    save() {
      this.isSaving = true;

      const update = {};

      Object.values(this.issueEditFields)
        .filter(field => includeField(field))
        .forEach(field => {
          update[field.key] = [
            {
              set: this.issue.fields[field.key],
            },
          ];
        });

      const updateData = {
        update: update,
      };

      $.ajax(`/jira/edit_issue?id=${encodeURIComponent(this.issue.id)}`, {
        type: 'POST',
        data: JSON.stringify(updateData),
        contentType: 'application/json',
        headers: { 'X-CSRF-Token': this.csrfToken || window.GGRC.csrfToken },
      }).then(
        res => {
          this.updateIssue(res);

          this.isSaving = false;
          this.isEditing = false;
        },
        err => {
          this.isSaving = false;

          window.GGRC.Notify({
            type: 'error',
            message: err.responseJSON.message,
          });
        }
      );
    },
    transitionIssue(transition) {
      const url = '/jira/transition_issue?id=' + encodeURIComponent(this.issue.id);

      return $.ajax(url, {
        type: 'POST',
        data: JSON.stringify({
          transitionId: transition.id,
        }),
        contentType: 'application/json',
        headers: { 'X-CSRF-Token': this.csrfToken || window.GGRC.csrfToken },
      }).then(
        res => {
          this.updateIssue(res);
        },
        err => {
          window.GGRC.Notify({
            type: 'error',
            message: err,
          });
          throw err;
        }
      );
    },
    addComment(newComment) {
      const url = '/jira/issue_add_comment?id=' + encodeURIComponent(this.issue.id);

      return $.ajax(url, {
        type: 'POST',
        data: JSON.stringify({
          comment: newComment,
        }),
        contentType: 'application/json',
        headers: { 'X-CSRF-Token': this.csrfToken || window.GGRC.csrfToken },
      }).then(
        res => {
          this.updateIssue(res);
        },
        err => {
          window.GGRC.Notify({
            type: 'error',
            message: err,
          });
          throw err;
        }
      );
    },
  },
});
